// extracted by mini-css-extract-plugin
module.exports = {"tag":"TenderStatusTag_tag__WnP0O"};